import React, { useState } from 'react';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const EmailInput = ({question, currentValue, inputChange, emailCheck}) => {
  const [email, setEmail] = useState(currentValue);
  const [emailError, setEmailError] = useState(false);

  const handleInputChange = (e) => {
    // Handle input change
    const name = e.target.name;
    let value;
    if(e.target.type === "number"){
      value = parseInt(e.target.value);
    } else {
      value = e.target.value;
    }
    inputChange(name, value);
  };

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const handleEmailChange = (e) => {
    handleInputChange(e);
    const value = e.target.value;
    setEmail(value);
    setEmailError(!validateEmail(value));
    emailCheck(emailError);
    //console.log(emailError);
  };

  return (
    <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">* {question}</InputLabel>
        <Input
        title="Email"
        name="Email"
        label="Email"
        variant="filled"
        size="small"
        value={email}
        onChange={handleEmailChange}
        error={emailError}
        helpertext={emailError ? 'Invalid email address' : ''}
        />
    </FormControl>
  );
};

export default EmailInput;
